import React, { FC, TextareaHTMLAttributes, useId } from 'react';
import { twMerge } from 'tailwind-merge';

interface IProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

const Textarea: FC<IProps> = ({ value, label, error, ...rest }) => {
  const id = useId();
  return (
    <label htmlFor={id}>
      <div
        className={twMerge(
          'w-full max-w-[488px]  min-h-[65px] border border-k-input-border flex flex-col p-3 rounded-[12px] relative group focus-within:border-k-black focus-within:shadow-border has-[input:not(:placeholder-shown)]:border-k-black has-[input:not(:placeholder-shown)]:shadow-border',
          error &&
            'border-k-error focus-within:shadow-border_error focus-within:border-k-error'
        )}
      >
        <textarea
          className='w-full peer border border-k-black outline-none border-none text-lg mt-5 placeholder:text-transparent resize-none'
          placeholder='hi'
          value={value}
          rows={3}
          {...rest}
        ></textarea>
        <p
          className={twMerge(
            'text-lg text-k-grey-text absolute top-[16px] peer-[:focus]:text-sm peer-[:focus]:top-[6px] peer-[:not(:placeholder-shown)]:text-sm  peer-[:not(:placeholder-shown)]:top-[6px] transition-[top] duration-200 ease pointer-events-none',
            error && 'text-k-error'
          )}
        >
          {label}
        </p>
      </div>
    </label>
  );
};

export default Textarea;
